<template>
    <div class="mx-2 mx-lg-5">
        <div class="card my-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ $t("headers.mobileDevice") }}</h3>
                <div>
                    <button
                        class="btn btn-warning btn-sm me-2"
                        @click.stop="toggleDevice(mobileDevice.id)"
                        :title="mobileDevice.is_active ? 'Deaktivovat zarizeni' : 'Aktivovat zarizeni'"
                    >
                        <icon :icon="mobileDevice.is_active ? 'Lock' : 'LockOpen'"></icon>
                    </button>
                    <button class="btn btn-sm btn-danger" @click="deleteDevice">
                        <icon icon="Trash"></icon>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <div class="row mb-0">
                            <dt class="col-sm-4">{{ $t("device.deviceName") }}</dt>
                            <dd class="col-sm-8">{{ mobileDevice.device_name }}</dd>

                            <dt class="col-sm-4">{{ $t("device.manufacturer") }}</dt>
                            <dd class="col-sm-8">{{ mobileDevice.manufacturer }}</dd>

                            <dt class="col-sm-4">{{ $t("device.operatingSystem") }}</dt>
                            <dd class="col-sm-8">{{ mobileDevice.operating_system }}</dd>

                            <dt class="col-sm-4">{{ $t("device.osVersion") }}</dt>
                            <dd class="col-sm-8">{{ mobileDevice.os_version }}</dd>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row mb-0">
                            <dt class="col-sm-4">{{ $t("device.lastSeen") }}</dt>
                            <dd class="col-sm-8">{{ mobileDevice.last_seen ? $d(new Date(mobileDevice.last_seen), 'long') : "--" }}</dd>

                            <dt class="col-sm-4">{{ $t("device.lastCoordinates") }}</dt>
                            <dd class="col-sm-8">
                                {{ mobileDevice.last_latitude != null && mobileDevice.last_longitude != null
                                    ? mobileDevice.last_latitude + ", " + mobileDevice.last_longitude
                                    : "--"
                                }}
                            </dd>

                            <dt class="col-sm-4">{{ $t("device.batteryLabel") }}</dt>
                            <dd class="col-sm-8">
                                <icon
                                    :icon="mobileDevice.is_charging ? 'BatteryCharging' : 'Battery'"
                                    class="me-1"
                                />
                                <span>{{ mobileDevice.battery_level }}%</span>
                            </dd>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card my-3">
            <div class="card-header">
                <h3>{{ $t("device.monitoring.label") }}</h3>
            </div>
            <div class="card-body">
                <div class="form-check form-switch mb-3 filter_switch">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="monitorLocation"
                        v-model="mobileDevice.monitor_location"
                        @change="updateMonitoring({ monitor_location: mobileDevice.monitor_location })"
                    >
                    <label class="form-check-label fw-bold" for="monitorLocation">
                        <span>{{ $t("device.monitoring.location") }}</span>
                        <span>
                            <small class="text-muted ms-1">
                                ({{ $t("device.monitoring.locationDesc") }})
                            </small>
                        </span>
                    </label>
                </div>

                <div class="form-check form-switch mb-3 filter_switch">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="monitorBattery"
                        v-model="mobileDevice.monitor_battery"
                        @change="updateMonitoring({ monitor_battery: mobileDevice.monitor_battery })"
                    >
                    <label class="form-check-label fw-bold" for="monitorBattery">
                        <span>{{ $t("device.monitoring.battery") }}</span>
                        <span>
                            <small class="text-muted ms-1">
                                ({{ $t("device.monitoring.batteryDesc") }})
                            </small>
                        </span>
                    </label>
                </div>

                <div class="form-check form-switch filter_switch">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="monitorFall"
                        v-model="mobileDevice.monitor_fall"
                        @change="updateMonitoring({ monitor_fall: mobileDevice.monitor_fall })"
                    />
                    <label class="form-check-label fw-bold" for="monitorFall">
                        <span>{{ $t("device.monitoring.fall") }}</span>
                        <span>
                            <small class="text-muted ms-1">
                                ({{ $t("device.monitoring.fallDesc") }})
                            </small>
                        </span>
                    </label>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <h3>Lokace</h3>
            </div>
            <div class="card-body">
                <MapView
                    v-if="mobileDevice.last_latitude != null && mobileDevice.last_longitude != null"
                    :device="{
                        latitude: mobileDevice.last_latitude,
                        longitude: mobileDevice.last_longitude,
                        name: mobileDevice.device_name
                    }"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import MapView from '@/components/dashboard/MapView.vue';

export default {
    components: {
        Icon,
        MapView,
    },
    data() {
        return {
            mobileDevice: {},
            poller: null,
        }
    },
    created() {
        this.getMobileDevice();
        this.startPolling();
    },
    beforeUnmount() {
        clearInterval(this.poller);
    },
    methods: {
        getMobileDevice() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/mobile-devices/${this.$route.params.id}`)
            .then(response => {
                this.mobileDevice = response.data
            })
            .catch(error => {
                console.error("Error loading mobile device. ", error)
            });
        },
        deleteDevice() {
            const confirm = window.confirm(this.$t("utils.deleteConfirm", { name: this.mobileDevice.device_name }));
            if (!confirm) return;

            this.$store.getters.api.delete(`/dashboard/${this.$route.params.slug}/mobile-devices/${this.$route.params.id}/delete`)
            .then(() => {
                this.$router.push({
                    name: "MobileDeviceListView",
                    params: {
                        slug: this.$route.params.slug
                    }
                })
            })
        },
        toggleDevice(deviceId) {
            this.$store.getters.api.patch(`/dashboard/${this.$route.params.slug}/mobile-devices/${deviceId}/toggle-active`)
            .then(() => {
                this.getMobileDevice();
            })
            .catch(error => {
                console.error("Error toggling device.", error);
            });
        },

        startPolling() {
            this.poller = setInterval(() => {
                this.getMobileDevice();
            }, 10000);
        },

        updateMonitoring(data) {
            this.$store.getters.api.patch(`/dashboard/${this.$route.params.slug}/mobile-devices/${this.mobileDevice.id}/monitoring`, data)
            .catch(error => {
                console.error("Error updating monitoring", error);
            });
        }
    }
}
</script>

<style scoped>
.filter_switch {
    .form-check-input {
        width: 40px;
        height: 20px;
        cursor: pointer;
    }
    .form-check-label {
        margin-left: 12px;
        font-size: 16px;
        cursor: pointer;
    }
}
</style>